<template>
  <div>
    <modal
      name="aboutModal"
      :scrollable="true"
      delay="2000"
      width="100%"
      height="auto"
      style="z-index: 9998;"
      @closed="closeModal"
    >
      <div id="modalAreaAbout" class="modalArea">
        <div class="content">

          <h2>日本写真100景とは？</h2>
          <p>
            2012年に設立した東京カメラ部とその分室は、ファン総数576万人を超える方々にご覧いただけるようになりました。この実現には素晴らしい景観が欠かせませんが、特に日本の地方は人口減少などの影響を受けて良好な景観の維持・運用が厳しい状況にあります。<br><br>

            そうした背景から、東京カメラ部は環境省・国立公園オフィシャルパートナーになるなど、名勝地の写真撮影マナー問題、写真スポット整備、告知への協力を続けています。御存知の方もいらっしゃるかもしれませんが、Visit Japan施策の成功などもあり課題はあったものの一部の地域ではその成果を出しつつありました。<br><br>

            しかしながら、世界を襲った感染症によって日本を含む世界中の観光業は過去に例がない甚大な被害を受けました。そして、現在、報道されているように一部地域はオーバーツーリズムに悩むレベルまで復活を遂げましたが、まだまだ被害からの復旧は道半ばという地域が多数存在します。<br><br>

            この問題を少しでも改善するため、日本全国の名勝地や観光業の支援を視野に入れ、2020年から実施しているのが「日本写真100景」フォトコンテストです。<br><br>

            入選作品は、観光誘致につなげるために撮影地情報と季節のご入力をお願いしています。また、その趣旨から「主体となる被写体は、風景、街、生活の営みと景観、文化などが対象」とも限定しています。<br><br>

            これらの制約にも関わらず、コンテストの趣旨に賛同してくれた数多くの方々からご応募をいただき、初年度は16,000作品以上、それ以降も、毎年前年を更新し続けています。<br><br>

            この日本写真100景は、そうして集まった見事な作品の中から選びぬかれた作品です。ぜひ、これら珠玉の作品群をご堪能ください。<br><br>

            また、応募いただいたすべての方に心から御礼を申し上げるとともに、期待に添えるよう日本全国の名勝地、観光業の支援を行っていくことを約束します。本当にありがとうございました。<br><br>
          </p>
          <p class="commentEnd">
            2026年1月吉日<br>
            東京カメラ部運営代表<br>
            塚崎秀雄
          </p>

        </div><!-- /content -->
      </div><!-- /modalArea -->
      <div v-if="open" class="closeModalBotton fade" @click="closeModal"><img src="/img/blank.gif"></div>
    </modal>
  </div>
</template>

<script>
export default {
  props: [
    'open'
  ],
  methods: {
    closeModal () {
      this.$emit('update:open', false)
      this.$modal.hide('aboutModal')
      const path = '/'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '東京カメラ部 日本写真100景 ～日本は発見を待っている。～'
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.$modal.show('aboutModal')
      }
    }
  }
}
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}
.vm--modal {
  background-color:rgba(0,0,0,0) !important;
}
</style>
